import Model from './Model'

export default class Supplier extends Model
{
    toDropdown() {
        return { label: this.name, value: `${this.type}_${this.id}` }
    }

    static async search (query) {
        const params = { query }
        const { data } = await Http.get(route('api.v1.suppliers.options'), { params })
        return this.make(data)
    }
}
